// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

const QUERY_IDENTITIES = gql`
  query($description: String!) {
    identities(responsibilities_Description: $description, first: 1) {
      edges {
        node {
          id
        }
      }
    }
  }
`


export const IdentityWithResponsibility = ({ responsibilityDescription }) => (
  <Query query={QUERY_IDENTITIES} variables={{ description: responsibilityDescription }}>
    {({ loading, error, data }) => {
      if (loading || error) {
        return null
      }

      return data.identities.edges[0].node.id
    }}
  </Query>
)



// WEBPACK FOOTER //
// ./src/components/identity-with-responsibility/index.js